import gql from 'graphql-tag';

export default gql`
  mutation deleteChannelRelationship($id: UUID!) {
    deleteChannelRelationship(_id: $id)
  }
`;
